@if (!stepState.isRfiFinished()) {
  <div class="flex flex-row justify-items-center items-center text-center gap-4 mb-4">
    <i class="pi pi-exclamation-triangle text-4xl!"></i>
    <span class="font-bold text-lg"> {{ 'project.finishRfiFirst.message' | transloco }} </span>
    <p-button
      [label]="'project.finishRfiFirst.label' | transloco"
      [pTooltip]="'project.finishRfiFirst.tooltip' | transloco"
      (onClick)="navigateToRfi()"
      data-testid="back-to-rfi"
    ></p-button>
  </div>
}

<ng-template #totalResultTemplate let-item>
  <app-result-score-cell [rfiPercentage]="item.rfiPercentage" [rfiWeight]="rfiWeightSum()" />
</ng-template>

<ng-template #reasonTemplate let-item>
  <p-button
    [label]="
      item.decisionReason
        ? ('project.steps.invitationList.reasonShow' | transloco)
        : ('project.steps.invitationList.reasonAdd' | transloco)
    "
    [severity]="
      item.decisionReason ? (item.selection === 'PARTICIPANT' ? 'success' : 'danger') : 'secondary'
    "
    size="small"
    (onClick)="openReasonModal(item)"
    data-testid="decision-reason-btn"
    [disabled]="!item.decisionReason && stepState.isCurrentStepFinished()"
  />
</ng-template>
<app-rfp-suitability-panel
  [tools]="matrixTools()"
  [locked]="isCurrentStepLocked()"
  [(mode)]="suitabilityMode"
  [(thresholds)]="thresholds"
  [(selectedToolId)]="selectedToolId"
  (selectionChange)="setSelection($event)"
/>

<ng-template #providerTemplate let-item>
  <button
    type="button"
    class="cursor-pointer text-left underline decoration-dotted underline-offset-4"
    (click)="selectTool(item.id)"
    data-testid="select-provider-in-matrix"
  >
    {{ item.toolProvider.name }}
  </button>
</ng-template>

<ng-template #coverageTemplate let-item>
  <app-rfp-coverage-cell [tool]="item" [mode]="suitabilityMode()" />
</ng-template>

<ng-template #dataCompletenessTemplate let-item>
  <span>{{ item.suitability?.dataCompleteness ?? 0 | appNumber: '1.0-0' }} %</span>
</ng-template>

<app-invitation-table
  [phaseConfig]="rfpPhaseConfig()"
  [projectId]="projectId"
  (currentPhaseChange)="onCurrentPhaseChange($event)"
  data-testid="rfp-invitations-table"
/>

<app-decision-reason-modal
  [visible]="reasonModalVisible()"
  [projectId]="projectId"
  [phaseType]="rfpPhaseConfig().phaseType"
  [tool]="selectedReasonTool()"
  [isStepFinished]="stepState.isCurrentStepFinished()"
  (visibleChange)="reasonModalVisible.set($event)"
  (saved)="onReasonSaved($event)"
/>
